var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Misc. / Star (Outline)",
    clipPath: "url(#clip0_8917_2892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.51055 6.72529L8 3.16568L6.48945 6.72529L2.62491 7.02895L5.56829 9.50015L4.66093 13.2284L8 11.2294L11.3391 13.2284L10.4317 9.50015L13.3751 7.02895L9.51055 6.72529ZM15.4909 5.81927C15.9824 5.85789 16.1801 6.46917 15.8034 6.78543L11.973 10.0013L13.1459 14.8206C13.2612 15.2941 12.7447 15.671 12.325 15.4197L8 12.8305L3.67505 15.4197C3.25525 15.671 2.73884 15.2941 2.85409 14.8206L4.02697 10.0013L0.196586 6.78543C-0.180107 6.46917 0.0176294 5.85789 0.509119 5.81927L5.54454 5.42361L7.4916 0.835369C7.68135 0.38821 8.31865 0.388211 8.50841 0.83537L10.4555 5.42361L15.4909 5.81927Z",
    fill: "#197A56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8917_2892"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutline);
export default __webpack_public_path__ + "static/media/star-outline.1b59985fe374d374dfe8a71e009bf5c5.svg";
export { ForwardRef as ReactComponent };